export default __webpack_public_path__ + "static/media/blue-cross.e4ac79b1.svg";